import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const LABEL_X = 250;
const startY = -200;
const YInterval = 60;
const COLORS = ["#003f5c", "#58508d", "#bc5090", "#ff6361", "#ffa600"];

const labelConfigurations = [
    { x: LABEL_X, y: startY, color: "#003f5c" },
    { x: LABEL_X, y: startY + YInterval, color: "#58508d" },
    { x: LABEL_X, y: startY + 2 * YInterval, color: "#bc5090" },
    { x: LABEL_X, y: startY + 3 * YInterval, color: "#ff6361" },
    { x: LABEL_X, y: startY + 4 * YInterval, color: "#ffa600" }
];

const renderCustomizedLabel = ({ id: categoryId, index, value, name, percentageDiff }, categorySelected) => {
    return (
        <g
            key={index}
            onClick={() => {
                categorySelected(categoryId, name);
            }}
        >
            <circle
                cx={labelConfigurations[index].x + 80}
                cy={labelConfigurations[index].y + 220}
                r={8}
                fill={labelConfigurations[index].color}
            />
            <text
                fill="black"
                fontSize="15"
                x={labelConfigurations[index].x + 60}
                y={labelConfigurations[index].y + 225}
                textAnchor="end"
            >
                {name}
            </text>
            <text
                fill="black"
                fontSize="16"
                fontWeight="bold"
                x={labelConfigurations[index].x + 60}
                y={labelConfigurations[index].y + 242}
                textAnchor="end"
            >
                {"₪" + value}
            </text>
            <text
                fill="black"
                fontSize="15"
                x={labelConfigurations[index].x + 60}
                y={labelConfigurations[index].y + 260}
                textAnchor="end"
            >
                {percentageDiff < 0 ? "" : "+"}
                {percentageDiff}%
            </text>
        </g>
    );
};

function SummaryPie(props) {
    const data = props.items;
    const categorySelected = props.categorySelected;

    return (
        <PieChart width={350} height={310}>
            <Pie
                isAnimationActive={false}
                data={data}
                labelLine={false}
                label={(data) => renderCustomizedLabel(data, categorySelected)}
                cx="30%"
                cy="50%"
                innerRadius={50}
                outerRadius={80}
                fill="#8884d8"
                paddingAngle={2}
                dataKey="value"
            >
                {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
            </Pie>
        </PieChart>
    );
}

export default SummaryPie;
